// extracted by mini-css-extract-plugin
module.exports = {"banner":"t_l","bannerContent":"t_cq","title":"t_f","description":"t_g","button":"t_B","logosContainer":"t_cr","uses":"t_bg"};